import {useMemo} from "react";
import MetricDashCard from "../../../../../../../../components/dash-card/metric-dash-card.jsx";
import SentryEchart from "../../../../../../../../components/echarts/sentry-echart.jsx";

export default function ProtectiveOverview({data}) {
    const protectiveMeasures = Array.isArray(data?.protectiveMeasures)
        ? data.protectiveMeasures
        : [];
    const measures = [
        protectiveMeasures[0] ?? {label: "Com medida protetiva", qty: 0},
        protectiveMeasures[1] ?? {label: "Sem medida protetiva", qty: 0},
    ];
    const sourceItems = data?.cpfRegistrationsByProgram;
    const registrationsByProgram = useMemo(() => Array.isArray(sourceItems)
        ? sourceItems.map(item => ({
            label: item.label ?? "",
            value: Number(item.qty) || 0,
        })).sort((first, second) => second.value - first.value).slice(0, 4)
        : [], [sourceItems]);

    const registrationsChart = useMemo(() => {
        const values = registrationsByProgram.map(item => item.value);
        const maxValue = Math.max(...values, 1);

        return {
            grid: {
                top: 20,
                left: 8,
                right: 8,
                bottom: 8,
                containLabel: true,
            },
            tooltip: {
                trigger: "axis",
                axisPointer: {type: "shadow"},
                formatter: params => {
                    const coloredBar = params.find(item => item.seriesName === "Quantidade");
                    const item = registrationsByProgram[coloredBar?.dataIndex];

                    return item?.label ? `${item.label}: <b>${item.value}</b>` : "";
                },
            },
            xAxis: {
                type: "category",
                boundaryGap: true,
                data: registrationsByProgram.map(item => item.label),
                axisLabel: {
                    color: "#AAAAAA",
                    fontSize: 12,
                    interval: 0,
                    width: 100,
                    overflow: "truncate",
                    ellipsis: "...",
                    formatter: value => {
                        const words = value.split(" ");

                        return words.length > 2
                            ? `${words.slice(0, 2).join(" ")}\n${words.slice(2).join(" ")}`
                            : value;
                    },
                },
                axisLine: {
                    show: true,
                    lineStyle: {color: "#555762"},
                },
                axisTick: {show: false},
            },
            yAxis: {
                type: "value",
                min: 0,
                max: maxValue,
                minInterval: 1,
                axisLabel: {
                    show: true,
                    color: "#AAAAAA",
                    fontSize: 12,
                },
                axisTick: {show: false},
                splitLine: {show: false},
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#555762",
                        width: 1,
                    },
                },
            },
            series: [
                {
                    name: "Quantidade",
                    type: "bar",
                    barWidth: 44,
                    itemStyle: {
                        borderRadius: [4, 4, 0, 0],
                        color: {
                            type: "linear",
                            x: 0,
                            y: 1,
                            x2: 1,
                            y2: 0,
                            colorStops: [
                                {offset: 0, color: "#003878"},
                                {offset: 0.5, color: "#0080ED"},
                                {offset: 1, color: "#1CEAE6"},
                            ],
                        },
                    },
                    label: {
                        show: true,
                        position: "top",
                        distance: 8,
                        color: "#FDFCFF",
                        fontSize: 12,
                        fontWeight: "bold",
                        formatter: params => values[params.dataIndex],
                    },
                    data: values,
                    z: 2,
                },
            ],
        };
    }, [registrationsByProgram]);

    return (
        <article className="box-border grid h-full min-h-0 min-w-0 w-full grid-rows-[23%_77%] gap-y-3">
            <section className="grid min-h-0 min-w-0 grid-cols-2 gap-2">
                {measures.map(measure => (
                    <MetricDashCard
                        counterCard
                        key={measure.label}
                        title={measure.label}
                        value={measure.qty ?? 0}
                        width="100%"
                        height={80}
                        dashClassName="min-w-0"
                        pClassName="text-[calc(var(--font-sm)-1px)]! 2xl:text-[calc(var(--font-md)-1px)]! leading-[1.15]!"
                    />
                ))}
            </section>
            <section className="min-h-0 min-w-0 flex flex-col overflow-hidden">
                <h3 className="shrink-0 px-4 text-center text-(length:--font-md)! text-[#AAAAAA]">
                    Cadastros por programa
                </h3>
                <div className="flex-1 min-h-0 px-2 pb-1">
                    <SentryEchart
                        className="h-full min-h-0 w-full"
                        option={registrationsChart}
                    />
                </div>
            </section>
        </article>
    )
}
